import { ease } from "@studiometa/js-toolkit/utils";
const regex = /ease([A-Z])/;
const eases = Object.fromEntries(
  Object.entries(ease).filter(([name]) => name.startsWith("ease")).map(([name, value]) => [name.replace(regex, (match, $1) => $1.toLowerCase()), value])
);
function animationScrollWithEase(ScrollAnimation) {
  class AnimationScrollWithEase extends ScrollAnimation {
    /**
     * Config.
     */
    static config = {
      ...ScrollAnimation.config,
      name: `${ScrollAnimation.config.name}WithEase`,
      options: {
        ...ScrollAnimation.config.options,
        ease: {
          type: String,
          default: "outExpo"
        }
      }
    };
    /**
     * Eases the progress value.
     */
    render(progress) {
      if (typeof eases[this.$options.ease] === "function") {
        progress = eases[this.$options.ease](progress);
      }
      super.render(progress);
    }
  }
  return AnimationScrollWithEase;
}
export {
  animationScrollWithEase
};
//# sourceMappingURL=animationScrollWithEase.js.map
